/* eslint-disable react/prop-types */
import Button from 'components/base/Button';
import Icon from 'components/icon';
import roles from 'data/roles';
import useCheckPermission from 'hooks/custom/useCheckPermission';
import { useAdvanceTableContext } from 'providers/AdvanceTableProvider';
import { useAlert } from 'providers/AlertModalProvider';
import { useEffect, useState } from 'react';
import exportToCSV from 'services/exportToCSV';
import { formatDate } from 'services/utils';

const ExcelButton = ({
  prefix,
  allFields = false,
  allowRoles = roles,
  onlyTableFields = false
}) => {
  const table = useAdvanceTableContext();
  const [loading, setIsLoading] = useState(true);
  const [isExport, setIsExport] = useState(false);
  const [exportableData, setExportableData] = useState([]);
  const { userAllow, role } = useCheckPermission(allowRoles);
  const { showAlert } = useAlert();

  useEffect(() => {
    if (isExport) {
      setTimeout(() => {
        setIsExport(false);
      }, 4000);
    }
  }, [isExport]);

  useEffect(() => {
    if (userAllow) {
      setIsLoading(true);
      const filteredData = table.getFilteredRowModel();
      if (filteredData?.rows?.length > 0) {
        if (
          (role === 'Admin' || role === 'Manager' || allFields) &&
          !onlyTableFields
        ) {
          const allData = [];
          filteredData?.rows?.forEach(row => {
            allData.push(row.original);
          });
          setExportableData(allData);
        } else {
          console.log(
            '🚀 ~ useEffect ~ filteredData?.rows:',
            filteredData?.rows[0].getAllCells()
          );

          const separateData = [];

          filteredData?.rows?.forEach(row => {
            const pureData = {};
            row.getAllCells()?.forEach(cell => {
              if (cell.column.id !== 'select' && cell.column.id !== 'action') {
                pureData[
                  typeof cell.column.columnDef.header === 'string'
                    ? cell.column.columnDef.header
                    : cell.column.columnDef.header().props.children[1].props
                        .children
                ] = cell.getValue();
              }
            });
            separateData.push(pureData);
          });
          setExportableData(separateData);
        }
      } else {
        setExportableData([]);
      }

      setIsLoading(false);
    }
  }, [userAllow, role, allFields, table]);

  const handleExport = () => {
    const todayDate = formatDate(new Date(), 'DD MMMM YYYY');
    try {
      exportToCSV(exportableData, `${prefix} ${todayDate}`);
      setIsExport(true);
    } catch (error) {
      showAlert({
        variant: 'danger',
        message: `Failed to export ${prefix}.`
      });
    }
  };
  return (
    <>
      {!loading && userAllow ? (
        <Button
          className="p-2 position-relative text-success"
          variant="phoenix-primary"
          title="Download XLS"
          disabled={isExport || exportableData?.length === 0}
          onClick={handleExport}
        >
          <Icon
            icon={
              isExport
                ? 'icon-park-outline:check-small'
                : 'vscode-icons:file-type-excel'
            }
          />
        </Button>
      ) : null}
    </>
  );
};

export default ExcelButton;
